t = require('views/internal/teacup-with-helpers')('card_detail_subscribe')

module.exports = t.renderable ({ subscribed, subscribeString, subscribeAltString }) ->
  classes =
    'button-link': true
    'is-on': subscribed
    'js-subscribe': !subscribed
    'js-unsubscribe': subscribed
  t.a { class: t.classify(classes), title: t.l(subscribeAltString) }, ->
    t.icon 'subscribe', subscribeString
    t.span '.on', ->
      t.icon 'check', { class: 'light' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/card_detail_subscribe.coffee